import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { ExportService } from 'src/app/Service/export.service';
// / Helper function to convert time in 'hh:mm:ss' format to total seconds
function timeToSeconds(time: string): number {
  if (!time) return 0;
  const parts = time.split(':').map((part) => parseInt(part, 10));

  // Ensure the parts array contains 3 values (HH:mm:ss)
  const hours = parts[0] || 0;
  const minutes = parts[1] || 0;
  const seconds = parts[2] || 0;

  return hours * 3600 + minutes * 60 + seconds; // Convert to seconds
}

// Helper function to convert total seconds to 'hh:mm:ss' format
function secondsToTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const sec = seconds % 60;

  return `${padZero(hours)}:${padZero(minutes)}:${padZero(sec)}`;
}

// Helper function to pad numbers with leading zero if needed
function padZero(number: number): string {
  return number < 10 ? '0' + number : number.toString();
}

@Component({
  selector: 'app-monthly-billing',
  templateUrl: './monthly-billing.component.html',
  styleUrls: ['./monthly-billing.component.css'],
})
export class MonthlyBillingComponent implements OnInit {
  constructor(
    public _apiService: ApiService,
    private notificationService: NzNotificationService,
    private datePipe: DatePipe,
    public cookie: CookieService,
    private _exportService: ExportService
  ) {}

  formTitle = 'Project Wise Monthly Billing';
  loadprojectexcel: boolean = false;
  loadingRecords = false;
  totalAmount = 0;
  totalTime: any = 0;
  totalRatePerHour = 0;
  totalInvoiceRaised = 0;
  totalReceived = 0;
  totalPending = 0;
  totalDays = 0;
  isTotalRow = false;

  year: number;
  month: Date; // Keep month as Date object
  monthnumber: any;
  ngOnInit(): void {
    // Initialize the month to the current date
    const currentDate = new Date();
    this.yearChange(currentDate); // Call yearChange to set the initial values
  }

  // Disable next year
  disabledDate = (current: Date): boolean => {
    // Disable dates beyond current year
    return current && current.getFullYear() > new Date().getFullYear();
  };

  yearChange(data: Date | null) {
    if (data) {
      this.year = data.getFullYear();
      this.month = new Date(data.getFullYear(), data.getMonth(), 1);
      this.monthnumber = data.getMonth() + 1;
    } else {
      const currentDate = new Date();
      this.year = currentDate.getFullYear();
      this.month = currentDate;
      this.monthnumber = currentDate.getMonth() + 1;
    }

    // Log the extracted year and month

    this.getUserWiseSummary(true);
  }

  dt = new Date();
  // monthzzzz
  START_DATE: string;
  END_DATE: string;
  radioValue = 'E';

  getMonthAndYear() {
    // this.month = this.dt.getMonth();
    this.year = this.dt.getFullYear();
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = 'desc';
  logtext: string = '';
  searchText: string = '';
  columns: string[][] = [
    ['PROJECT', 'Project'],
    ['MODULE', 'Module'],
    ['FEATURE', 'Feature'],
    ['TASK', 'Task'],
    ['SUBTASK', 'Subtask'],
  ];
  filterQuery: string = '';
  isProjectSpinning = false;
  // loadingRecords = false;
  projectData = [];
  projectDataForExcel = [];
  date = new Date();

  getUserWiseSummary(reset: boolean = false) {
    var ok = true;
    // if (this.MODULE_ASSIGNEE_ID.length == 0) {
    //   ok = false
    // }

    this.loadingRecords = true;

    if (ok) {
      this.applyFilter();

      // API Call
      this._apiService.getMonthlyBilling(this.year, this.monthnumber).subscribe(
        (data) => {
          if (data['code'] == '200') {
            this.loadingRecords = false;
            this.projectData = data['results'];

            // Process and map data
            this.projectData = this.projectData.map((data) => {
              data.PROJECT_NAME = data.PROJECT_NAME.replace(/[-_]/g, ' ');
              return data;
            });

            // Add TOTAL_DAYS to each project based on TOTAL_TIME
            this.projectData = this.calculateTotalDays(this.projectData);
            // Calculate totals after data is fetched

            this.calculateTotals();
          } else {
            this.projectData = [];
            this.loadingRecords = false;
            // this.notificationService.error('Failed to fetch data', 'Error');
          }
        },
        (err) => {
          this.loadingRecords = false;
          if (err['ok'] == false) {
            this.notificationService.error('Server Not Found', 'Error');
          } else {
            this.notificationService.error('An error occurred', 'Error');
          }
        }
      );
    }
  }

  // Calculate total days from TOTAL_TIME
  calculateTotalDays(ProjectData: any[]): any[] {
    return ProjectData.map((employee) => {
      if (employee.TOTAL_TIME) {
        // Split the TOTAL_TIME into hours, minutes, and seconds
        const timeParts = employee.TOTAL_TIME.split(':');
        const hours = parseInt(timeParts[0], 10);
        const minutes = parseInt(timeParts[1], 10);
        const seconds = parseInt(timeParts[2], 10);

        // Calculate the total hours
        const totalHours = hours + minutes / 60 + seconds / 3600;

        // Calculate the total days by dividing the total hours by 24
        const totalDays = totalHours / 8;

        // Add the TOTAL_DAYS to the project record
        return {
          ...employee,
          TOTAL_DAYS: totalDays.toFixed(2), // Rounded to 2 decimal places
        };
      }

      // If there is no TOTAL_TIME, return the project data as is
      return employee;
    });
  }
  // Method to calculate totals for all relevant fields
  calculateTotals() {
    // Calculate total amount and round it to 2 decimal places
    this.totalAmount = parseFloat(
      this.projectData
        .reduce((sum, data) => sum + (data.TOTAL_AMOUNT || 0), 0)
        .toFixed(2)
    );

    // Calculate total time (in seconds) and convert to 'hh:mm:ss' format
    const totalSeconds = this.projectData.reduce(
      (sum, data) => sum + timeToSeconds(data.TOTAL_TIME),
      0
    );
    this.totalTime = secondsToTime(totalSeconds);

    // Calculate other totals
    this.totalRatePerHour = this.projectData.reduce(
      (sum, data) => sum + (data.RATE_PER_HOUR || 0),
      0
    );
    this.totalInvoiceRaised = this.projectData.reduce(
      (sum, data) => sum + (data.INVOICE_RAISED || 0),
      0
    );
    this.totalReceived = this.projectData.reduce(
      (sum, data) => sum + (data.RECIVED || 0),
      0
    );
    this.totalPending = this.projectData.reduce(
      (sum, data) => sum + (data.PENDING || 0),
      0
    );

    // Calculate total days (sum of TOTAL_DAYS)
    this.totalDays = this.projectData
      .reduce((sum, data) => sum + parseFloat(data.TOTAL_DAYS || '0'), 0)
      .toFixed(2); // Round to 2 decimal places

    // Flag to show total row after calculation
    this.isTotalRow = true;
  }

  importInExcel() {
    var arry1 = [];
    var obj1: any = new Object();
    this.loadprojectexcel = true;
    this.projectDataForExcel = [];

    // Get Data for Excel Sheet
    if (this.projectData) {
      this.projectDataForExcel = this.projectData;
      this.loadprojectexcel = false;

      if (this.projectData.length > 0) {
        // Calculate totals first
        let totalAmount = 0;
        let totalTimeInSeconds = 0; // For Total Time
        let totalRatePerHour = 0;
        let totalInvoiceRaised = 0;
        let totalReceived = 0;
        let totalPending = 0;
        let totalDays = 0; // To store total days

        // Iterate through data to calculate totals and map to the export format
        for (var i = 0; i < this.projectDataForExcel.length; i++) {
          this.projectDataForExcel[i].PROJECT_NAME = this.projectDataForExcel[
            i
          ].PROJECT_NAME.replace(/[-_]/g, ' ');

          // Map the table fields to the export data
          obj1['Project Name'] = this.projectDataForExcel[i]['PROJECT_NAME']; // Project Name
          obj1['Date'] = this.datePipe.transform(
            this.projectDataForExcel[i]['DATE'],
            'dd-MMM-yyyy'
          ); // Date
          obj1['Total Amount'] =
            this.projectDataForExcel[i]['TOTAL_AMOUNT'].toFixed(2); // Total Amount
          obj1['Total Time'] = this.projectDataForExcel[i]['TOTAL_TIME']; // Total Time
          obj1['Rate per Hour'] =
            this.projectDataForExcel[i]['RATE_PER_HOUR'].toFixed(2); // Rate per Hour
          obj1['Invoice Raised'] =
            this.projectDataForExcel[i]['INVOICE_RAISED'].toFixed(2); // Invoice Raised
          obj1['Received'] = this.projectDataForExcel[i]['RECIVED'].toFixed(2); // Received
          obj1['Pending'] = this.projectDataForExcel[i]['PENDING'].toFixed(2); // Pending
          obj1['Total Days'] = this.projectDataForExcel[i]['TOTAL_DAYS']; // Total Days

          // Add the object to the array
          arry1.push(Object.assign({}, obj1));

          // Update totals
          totalAmount += this.projectDataForExcel[i]['TOTAL_AMOUNT'] || 0;
          totalTimeInSeconds += timeToSeconds(
            this.projectDataForExcel[i]['TOTAL_TIME']
          );
          totalRatePerHour += this.projectDataForExcel[i]['RATE_PER_HOUR'] || 0;
          totalInvoiceRaised +=
            this.projectDataForExcel[i]['INVOICE_RAISED'] || 0;
          totalReceived += this.projectDataForExcel[i]['RECIVED'] || 0;
          totalPending += this.projectDataForExcel[i]['PENDING'] || 0;
          totalDays +=
            parseFloat(this.projectDataForExcel[i]['TOTAL_DAYS']) || 0; // Add to totalDays
        }

        // Convert total time from seconds to hh:mm:ss format
        let totalTime = secondsToTime(totalTimeInSeconds);

        // Add an empty row before the total row
        arry1.push({});

        // Add a row for totals
        let totalsRow: any = {};
        totalsRow['Project Name'] = 'Total'; // Label for total row
        totalsRow['Date'] = ''; // Leave empty for the Date column
        totalsRow['Total Amount'] = totalAmount.toFixed(2); // Round to 2 decimal places
        totalsRow['Total Time'] = totalTime; // Formatted total time
        totalsRow['Rate per Hour'] = totalRatePerHour.toFixed(2); // Round to 2 decimal places
        totalsRow['Invoice Raised'] = totalInvoiceRaised.toFixed(2); // Round to 2 decimal places
        totalsRow['Received'] = totalReceived.toFixed(2); // Round to 2 decimal places
        totalsRow['Pending'] = totalPending.toFixed(2); // Round to 2 decimal places
        totalsRow['Total Days'] = totalDays; // Add total days

        // Add the total row to the export array
        arry1.push(totalsRow);

        // Export to Excel
        this._exportService.exportExcel(arry1, 'Project Wise Monthly Billing');
      } else {
        this.notificationService.info('Data not found', '');
      }
    } else {
      this.projectDataForExcel = [];
      this.loadprojectexcel = false;
    }
  }

  // }

  // calculatePending(data: any, index: number): number {
  //   // Validation: Ensure received amount is not greater than invoice raised
  //   // if (data.RECIVED > data.INVOICE_RAISED) {
  //   //   this.notificationService.error('Received amount cannot be greater than Invoice Raised.', '');
  //   // }

  //   // Calculate pending amount
  //   let pending = data.INVOICE_RAISED - data.RECIVED;

  //   // Convert pending to a string and check its length
  //   let pendingStr = pending.toString();

  //   // If length exceeds 10 characters, truncate it
  //   if (pendingStr.length > 7) {
  //     pendingStr = pendingStr.slice(0, 7); // Truncate to 8 characters
  //     pending = parseFloat(pendingStr); // Convert it back to a number
  //   }

  //   data.PENDING = pending; // Update PENDING value in the data model
  //   return pending; // Return the calculated PENDING value
  // }

  calculatePending(data: any, index: number): number {
    // Ensure that both INVOICE_RAISED and RECIVED are parsed as numbers
    const invoiceRaised =
      data.INVOICE_RAISED != null
        ? parseFloat(data.INVOICE_RAISED.toString())
        : 0;
    const received =
      data.RECIVED != null ? parseFloat(data.RECIVED.toString()) : 0;

    // Log input values for debugging

    // Calculate the pending amount
    let pending = invoiceRaised - received;

    // Log the calculated pending value

    // Convert pending to a string and limit it to 7 characters (max length for the output)
    let pendingStr = pending.toFixed(2); // Ensures two decimal places are always shown

    // Log the string representation of the pending amount

    // If the length of the string exceeds 7 characters, we will slice it
    if (pendingStr.length > 12) {
      pendingStr = pendingStr.slice(0, 12); // Slice the first 7 characters (before truncating decimals)
    }

    // Log the truncated string

    // Convert the truncated string back to a number
    pending = parseFloat(pendingStr);

    // Log the final pending value

    // Update PENDING value in the data model
    data.PENDING = pending;

    // Return the calculated PENDING value
    return pending;
  }

  // Function to limit the length of input to the specified max length
  limitLength(event: any, maxLength: number): void {
    const value = event.target.value;

    // Only allow numbers and restrict to maxLength
    if (value.length > maxLength) {
      event.target.value = value.slice(0, maxLength); // Truncate input to maxLength
    }
  }

  updatemonthrecords: boolean = false;
  UpdateMonthData(): void {
    // Check if the project data is empty
    if (!this.projectData || this.projectData.length === 0) {
      this.notificationService.error('Project list is empty', '');
      return;
    }

    //   // Check if any PENDING value is negative and log the rows with negative values
    // const invalidRows = this.projectData.filter(project => project.PENDING < 0);
    // if (invalidRows.length > 0) {
    //   // Log the rows with invalid (negative) PENDING values
    //
    //   this.notificationService.error('Pending amount cannot be negative for  project ' + invalidRows[0]['PROJECT_NAME'], '');
    //   return;
    // }

    this.loadingRecords = true;

    const dataToSave = {
      data: this.projectData,
    };

    this.updatemonthrecords = true;
    this._apiService.updateMonthData(dataToSave).subscribe(
      (data) => {
        if (data['code'] == 200) {
          this.notificationService.success(
            'Month Data updated successfully',
            ''
          );
        } else {
          this.notificationService.error('Failed to push data', '');
        }
        this.loadingRecords = false;
        this.updatemonthrecords = false;
      },
      (error) => {
        console.error('Error:', error);
        this.notificationService.error(
          'An error occurred while updating sequence numbers',
          ''
        );
        this.loadingRecords = false;
        this.updatemonthrecords = false;
      }
    );
  }

  filterClass: string = 'filter-invisible';
  isFilterApplied: string = 'default';
  PROJECT_DATE = null;

  applyFilter() {
    this.isFilterApplied = 'primary';
    this.filterClass = 'filter-invisible';
  }

  showFilter(): void {
    if (this.filterClass === 'filter-visible')
      this.filterClass = 'filter-invisible';
    else this.filterClass = 'filter-visible';
  }
}
